module.exports = __webpack_public_path__ + "static/media/Clark_J@3x.3d00f817.jpg";